export class ContatoriVO {
  numeroBozzeUnitaDoc: number;
}
